export default __webpack_public_path__ + "static/media/gluten.8ba5050d.svg";